<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Electric Vehicles Notification Email Configuration</h4>
    <hr>
    <b-btn
      variant="success"
      size="sm"
      class="float-right mb-3"
      @click="$bvModal.show('config-modal')">
      <i class="fa fa-plus" />
      Add New
    </b-btn>
    <b-table
      v-if="items.length"
      :items="items"
      :fields="fields"
      responsive
      striped>
      <template v-slot:cell(evVehicles)="{ item }">
        <span v-for="vehicle in item.evVehicles" :key="vehicle" class="d-block">
          {{ vehicle }}
        </span>
      </template>
      <template v-slot:cell(action)="{ item }">
        <div class="d-flex">
          <b-btn
            size="sm"
            variant="secondary"
            class="mr-2"
            @click="handleEdit(item)">
            <i class="fa fa-edit" />
          </b-btn>
          <b-btn
            size="sm"
            variant="danger"
            @click="handleDelete(item)">
            <i class="fa fa-trash" />
          </b-btn>
        </div>
      </template>
    </b-table>

    <ElectricVehiclesConfigModal
      :mode="mode"
      :config="selectedItem"
      :vehicles="vehicles"
      @submit="handleSubmit" />
  </div>
</template>
<script>
import { toastr } from '@/services'
import ElectricVehiclesConfigModal from './ElectricVehiclesConfigModal'

export default {
  name: 'ElectricVehiclesConfig',
  components: {
    ElectricVehiclesConfigModal
  },
  data () {
    return {
      items: [],
      vehicles: [],
      selectedItem: undefined,
      mode: 'add',
      fields: [
        'emailAddress',
        'name',
        'evVehicles',
        'action'
      ]
    }
  },
  created () {
    this.getElectricVehicles()
    this.fetchData()
  },
  methods: {
    getElectricVehicles () {
      this.$store.dispatch('mrs/getElectricVehicles').then((data) => {
        this.vehicles = data
      })
    },
    fetchData () {
      this.$store.dispatch('mrs/getElectricVehicleConfig').then((data) => {
        this.items = data
      })
    },
    handleEdit(item) {
      this.selectedItem = item
      setTimeout(() => this.$bvModal.show('config-modal'), 150)
    },
    handleDelete(item) {
      this.$store.dispatch('mrs/deleteElectricVehicleConfig', item.receiverId)
        .then(() => {
          this.fetchData()
          toastr.info('Data has been removed', false, 300)
        })
    },
    handleSubmit(form) {
      this.$store.dispatch('mrs/upsertElectricVehicleConfig', form)
        .then(() => {
          toastr.success(false, 300)
          this.fetchData()
          this.$bvModal.hide('config-modal')
        })
    }
  }
}
</script>